import Heading from 'components/Heading'
import React from 'react'
import { useTranslation } from 'react-i18next'

const RobSludgeOilBilgeTab = () => {
  const { t } = useTranslation()

  return <Heading level={2}>{t('rob.survey.tabs.sludgeOilBilge')}</Heading>
}

export default RobSludgeOilBilgeTab
